import * as Accordionjs from 'accordion';  // es6 module

try {
  var accordions = [];
  var targets = document.querySelectorAll(".accordion");

  for(var i=0; i < targets.length; i++) {
    accordions[i] = new Accordion(targets[i], {
      modal: true,
    });
  }
} catch(err) {
  console.log(err);
}
